import { render } from "./set.vue?vue&type=template&id=5b79aa90"
import script from "./set.vue?vue&type=script&lang=js"
export * from "./set.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3432981287/src/catalog-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__